// constants
import { tableNames } from 'utils/constants';

// Column descriptors per BarnSheets table. `fixed` columns are always visible
// (the identity column); the rest are manageable — users can show/hide and
// reorder them via Manage Visible Fields. `labelId`/`labelValues` must match
// the column labels used in the matching table container. `metricLabelId`
// replaces `labelId` when the company measurement system is metric.
const groupsColumns = [
  { id: 'groupId', labelId: 'component.dataTable.headers.groupId', fixed: true },
  { id: 'farmName', labelId: 'component.dataTable.headers.farmName' },
  { id: 'type', labelId: 'general.type' },
  { id: 'abfStatus', labelId: 'general.abfStatus' },
  { id: 'healthStatus', labelId: 'general.healthStatus' },
  { id: 'startDate', labelId: 'component.dataTable.headers.startDate' },
  { id: 'daysOnFeed', labelId: 'general.daysOnFeed' },
  { id: 'pigsIn', labelId: 'general.pigsIn' },
  { id: 'totalMortality', labelId: 'component.dataTable.headers.totalMortality' },
  { id: 'inventory', labelId: 'component.dataTable.headers.inventory' },
  { id: 'headTreated', labelId: 'general.headTreated' },
  { id: 'mortRate', labelId: 'component.dataTable.headers.mortRate' },
  { id: 'estAvgWt', labelId: 'general.estAvgWt' },
  { id: 'treatedPeriod', labelId: 'general.treatedPeriod', labelValues: { period: '24h' } },
  { id: 'compliance', labelId: 'component.dataTable.headers.compliance' },
  { id: 'waterUsage', labelId: 'component.dataTable.headers.waterUsage' },
  { id: 'status', labelId: 'component.dataTable.headers.status' },
  { id: 'closeDate', labelId: 'component.dataTable.headers.closeDate' },
];

const farmsColumns = [
  { id: 'farmName', labelId: 'component.dataTable.headers.farmName', fixed: true },
  { id: 'type', labelId: 'general.type' },
  { id: 'openGroups', labelId: 'general.openGroups' },
  { id: 'inventory', labelId: 'component.dataTable.headers.inventory' },
  { id: 'mortRate', labelId: 'component.dataTable.headers.mortRate' },
  { id: 'totalMortality', labelId: 'component.dataTable.headers.totalMortality' },
  { id: 'treatedPeriod', labelId: 'general.treatedPeriod', labelValues: { period: '24HR' } },
  { id: 'waterUsage', labelId: 'component.dataTable.headers.currentGallonsConsumed',
    metricLabelId: 'component.dataTable.headers.currentLitersConsumed' },
  { id: 'compliance', labelId: 'component.dataTable.headers.compliance' },
];

const companiesColumns = [
  { id: 'companyName', labelId: 'general.companyName', fixed: true },
  { id: 'farms', labelId: 'general.farms' },
  { id: 'openGroups', labelId: 'general.openGroups' },
  { id: 'inventory', labelId: 'component.dataTable.headers.inventory' },
  { id: 'mortRate', labelId: 'component.dataTable.headers.mortRate' },
  { id: 'treatedPeriod', labelId: 'general.treatedPeriod', labelValues: { period: '24HR' } },
  { id: 'compliance', labelId: 'component.dataTable.headers.compliance' },
];

export const barnSheetsColumns = {
  [tableNames.barnSheetsGroups]: groupsColumns,
  [tableNames.barnSheetsFarms]: farmsColumns,
  [tableNames.barnSheetsCompanies]: companiesColumns,
};

export const manageableTableNames = Object.keys(barnSheetsColumns);

export const getAvailColumns = (tableName) => barnSheetsColumns[tableName] || [];

export const getInitialColumnKeys = (tableName) => {
  const columns = getAvailColumns(tableName);
  return {
    fixed: columns.filter(({ fixed }) => fixed).map(({ id }) => id),
    manageable: columns.filter(({ fixed }) => !fixed).map(({ id }) => id),
    hidden: [],
  };
};
